"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    updatePennyDebugger: ()=>updatePennyDebugger
});
const analytics_js_namespaceObject = require("../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const updatePennyDebugger = (submitChatMessagesPayload, chatMessages, headers)=>{
    if ('undefined' == typeof window) return;
    try {
        const indexedDB = window.indexedDB;
        const openRequest = indexedDB.open('PennyDB', 2);
        openRequest.onupgradeneeded = function(event) {
            const db = event.target.result;
            if (!db.objectStoreNames.contains('PennyDBStore')) {
                const objectStore = db.createObjectStore('PennyDBStore');
                objectStore.createIndex('pblb', 'pblb', {
                    unique: false
                });
            }
        };
        openRequest.onsuccess = function(e) {
            const db = e?.target?.result;
            if (db) {
                db.onerror = function(event) {
                    analytics_js_default().log({
                        source: 'updatePennyDebugger',
                        message: `Error occurred in writing data ${event.target.errorCode}`
                    });
                };
                const transaction = db.transaction([
                    'PennyDBStore'
                ], 'readwrite');
                const objectStore = transaction.objectStore('PennyDBStore');
                const request = objectStore.put({
                    data: {
                        submitChatMessagesPayload,
                        chatMessages,
                        headers
                    }
                }, 'pblb');
                request.onsuccess = function(e) {
                    analytics_js_default().log({
                        source: 'updatePennyDebugger',
                        message: 'Data has been written successfully'
                    });
                };
                request.onerror = function(e) {
                    analytics_js_default().log({
                        source: 'updatePennyDebugger',
                        message: `Error occurred in writing data ${e}`
                    });
                };
            }
        };
        openRequest.onerror = function(e) {
            analytics_js_default().log({
                source: 'updatePennyDebugger',
                message: `Error occurred in opening database ' ${e}`
            });
        };
    } catch (e) {
        analytics_js_default().log({
            source: 'updatePennyDebugger',
            message: `Error occurred in opening database ' ${e}`
        });
    }
};
exports.updatePennyDebugger = __webpack_exports__.updatePennyDebugger;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "updatePennyDebugger"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
